import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Dashboard.svg",
  "use": "Dashboard.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"Dashboard.svg\"><path d=\"M32.0105,56.0208a24,24,0,1,1,24-24A24,24,0,0,1,32.0105,56.0208Zm-13-12a2,2,0,0,0,2,2h22a2,2,0,0,0,2-2v-2a2,2,0,0,0-2-2h-22a2,2,0,0,0-2,2Zm13-32a20,20,0,0,0-20,20v.02a2.0214,2.0214,0,0,0,2.0425,1.98H27.642l-2.591-15.166a1.55,1.55,0,0,1,.9869-1.7521,1.492,1.492,0,0,1,1.8134.78l7.6047,16.138H49.9677a2.0219,2.0219,0,0,0,2.0428-1.98v-.02A20,20,0,0,0,32.0105,12.0208Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol